module.exports = __webpack_public_path__ + "media/customizations/pecansquarelife/back-c1ae07243c70fd46d61c3a924a05126b.jpg";